import { app } from '@/vendors/firebase/firebase';

export default {
  async getSettings() {
    const res = [];
    const snapshot = await app.firestore()
      .collection('appSettings')
      .limit(1)
      .get();

    snapshot.forEach((doc) => res.push(doc.data()));
    return res[0];
  },
};
